<template>
  <div class="f-h basic-gray-section gw-rating">
    <h1 class="basic-blue-title">{{ $t("message.GW_RATE_REVIEW") }}</h1>
    <div class="f-h-below-title">
      <PanelSplitter class="f-h" :allowHiding="[false, false]">
        <div class="f-h-below-subtitle" ref="panelCol1">
          <h3 class="legend mt10">{{ $t("message.GW_RATE_MOOD") }}</h3>
          <em class="mt10" v-html="$t('message.GW_RATE_MOOD_QUESTIONS')"></em><br/>
          <GwRater v-model="rating.ratingMood" />
          <div class="rating-comment">
            {{ commentHelperTitle() }}
          </div>
          <textarea class="bordered-field f-w mt5" v-model="rating.commentMood" @input="textareaAutoSize" :style="moodCommentStyle"></textarea>
        </div>
        <div class="f-h-below-subtitle" ref="panelCol2">
          <h3 class="legend mt10">{{ $t("message.GW_RATE_RELEVANCE") }}</h3>
          <em class="mt10" v-html="$t('message.GW_RATE_RELEVANCE_QUESTIONS')"></em><br/>
          <GwRater v-model="rating.ratingRelevance" />
          <div class="rating-comment">
            {{ commentHelperTitle(true) }}
          </div>
          <textarea class="bordered-field f-w mt5" v-model="rating.commentRelevance" @input="textareaAutoSize" :style="relevanceCommentStyle"></textarea>
        </div>
      </PanelSplitter>
      <button class="action-btn save-btn" @click="save">{{ $t('message.GW_SEND_RATING') }}</button>
    </div>
  </div>
</template>

<script>
import GwRater from '@/components/gw-rater.vue';
import PanelSplitter from '@/components/panel-splitter.vue';
// Import socket handling utils
import mixinSocketHandler from '@/mixins/socket-handler.vue';
import SocketMessages from '@/utils/classes/SocketMessages';
// Utils
import { textareaAutoSize } from '@/utils/main';

export default {
  name: 'GwRating',
  components: {
    GwRater,
    PanelSplitter,
  },
  mixins: [mixinSocketHandler],
  data() {
    return {
      rating: { id: 0, comment: '', ratingRelevance: 0, ratingMood: 0, commentMood: '', commentRelevance: '' },
      ratingThreshold: 7
    }
  },
  beforeRouteEnter(to, from, next) {
    next(function(comp) {
      comp.refresh();
    });
  },
  created() {
    this.handleSocketMessage(SocketMessages.CC_MSGS.GW_RATING, (msg) => {
      if (msg.id != this.$route.query.gwId) return;
      this.refresh();
    });
  },
  computed: {
    moodNeedsComment() {
      return this.rating.ratingMood > 0 && this.rating.ratingMood < this.ratingThreshold && this.rating.commentMood == '';
    },
    relevanceNeedsComment() {
      return this.rating.ratingRelevance > 0 && this.rating.ratingRelevance < this.ratingThreshold && this.rating.commentRelevance == '';
    },
    moodCommentStyle() {
      return this.moodNeedsComment ? { borderColor: '#c60d00' } : '';
    },
    relevanceCommentStyle() {
      return this.relevanceNeedsComment ? { borderColor: '#c60d00' } : '';
    }
  },
  methods: {
    /** Fetch the new data according to filters */
    refresh(includeData) {
      var self = this;
      this.App.post("/server/gembaWalks/getRatings.php", { id: this.$route.query.gwId }, function(d) {
        if (typeof d == 'object') {
          self.rating = d.id ? d : { id: 0, comment: '', ratingRelevance: 0, ratingMood: 0, commentMood: '', commentRelevance: '' };
        } else {
          toastr.error(self.$t('message.CONNECTION_ERROR'));
        }
      });
    },
    save() {
      if (this.moodNeedsComment || this.relevanceNeedsComment) {
        // If rating < 7, user should type a comment so that the auditor know what to improve
        calert(this.$t('message.GW_RATING_NEEDED_COMMENT'), [
          { title: this.$t('message.OK') }
        ]);
        return;
      }
      var self = this;
      this.App.post("/server/gembaWalks/setRating.php", { id: this.$route.query.gwId, rating: this.rating }, function(d) {
        if (d == '1') {
          self.sendSocketUpdate();
          toastr.success(self.$t('message.GW_REVIEW_SAVED'));
        } else {
          toastr.error(self.$t('message.CONNECTION_ERROR'));
        }
      });
    },
    commentHelperTitle(relevance) {
      var idx = relevance ? this.rating.ratingRelevance : this.rating.ratingMood;
      var com = idx < this.ratingThreshold && idx > 0 ?
        this.$t('message.GW_RATING_NEEDED_COMMENT') :
        this.$t('message.GW_RATING_OPTIONAL_COMMENT');
      return com + this.$t('message.TWO_DOTS');
    },
    sendSocketUpdate() {
      this.sendSocketMessage({ socketCompany: 1, id: this.$route.query.gwId, msg: SocketMessages.CC_MSGS.GW_RATING });
    },
    textareaAutoSize,
  }
};
</script>

<style lang="scss">
.gw-rating {
  .rater {
    margin-top: 35px;
  }
  .f-h-below-title {
    text-align: center;
  }
  .panel-splitter__panel {
    padding: 15px 20px;
  }
  em {
    display: inline-block;
  }
  .rating-comment {
    margin-top: 60px;
  }
}
</style>
